export default __webpack_public_path__ + "static/media/undraw_mail_sent_re_0ofv.b4eae181.svg";